document.addEventListener("DOMContentLoaded", function() {
    // Get the current URL
    var url = window.location.href;
    console.log('Current URL:', url); // Debugging line

    // Get all hidden input fields with the name 'contact[tags]'
    var inputFields = document.querySelectorAll('input[name="contact[tags]"]');
    
    inputFields.forEach(function(inputField) {
        if (url.includes('.com/cs')) {
            // If URL contains '.com/cs', add 'cs' to the value
            inputField.value = 'newsletter,cs';
        } else {
            // Otherwise, add 'en' to the value
            inputField.value = 'newsletter,en';
        }
        console.log('Updated input value:', inputField.value); // Debugging line
    });
});